module.exports = __webpack_public_path__ + "img/virtual.fdff6dbc.png";